'use client';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import style from '../style.module.scss';

interface TextSwiperProps {
  channelTextList: Array<{ channelText: string; channelType: number }>;
}

const TextSwiper = forwardRef<any, TextSwiperProps>(({ channelTextList }, ref) => {
  const swiperRef = useRef<any>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useImperativeHandle(ref, () => ({
    swiper: swiperRef.current?.swiper,
    getCurrentChannelType: () => channelTextList[currentIndex]?.channelType || 0,
    getCurrentItem: () => channelTextList[currentIndex],
  }));

  if (!channelTextList || channelTextList.length === 0) {
    return;
  }

  return (
    <div className={style.moreSwiper}>
      <div className={style.textSwiperContainer}>
        <Swiper
          ref={swiperRef}
          direction='vertical'
          slidesPerView={1}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          loop={channelTextList.length > 1}
          modules={[Autoplay]}
          className={style.textSwiperWrapper}
          allowTouchMove={false}
          onSlideChange={(swiper) => {
            // 处理循环轮播的真实索引
            setCurrentIndex(swiper.realIndex);
          }}
        >
          {channelTextList.map((item, index) => (
            <SwiperSlide
              key={index}
              className={style.textSwiperSlide}
              style={{ color: item.channelType === 0 ? '#888B94' : '#4843b8' }}
            >
              <div className={style.channelBox}>
                <span>{item.channelText}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
});

TextSwiper.displayName = 'TextSwiper';

export default TextSwiper;
